"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDerivation = exports.setDataModelTraining = exports.setLicenseFee = exports.setDuration = exports.udlToTags = void 0;
const udl_1 = require("../types/udl");
const contract_1 = require("../types/contract");
const bad_request_1 = require("../errors/bad-request");
const udlToTags = (udl) => {
    const tags = [];
    tags.push(new contract_1.Tag(udl_1.tagNames.LICENSE, udl.license || udl_1.UDL_LICENSE_TX_ID));
    if (udl.licenseFee) {
        tags.push(new contract_1.Tag(udl_1.tagNames.ACCESS_FEE, (0, exports.setLicenseFee)(udl.licenseFee)));
    }
    if (udl.commercialUses) {
        for (let commercialUse of udl.commercialUses) {
            tags.push(new contract_1.Tag((0, exports.setDuration)(commercialUse, udl_1.tagNames.COMMERCIAL_USE), commercialUse.type));
        }
    }
    if (udl.derivations) {
        for (let derivation of udl.derivations) {
            tags.push(new contract_1.Tag((0, exports.setDuration)(derivation, udl_1.tagNames.DERIVATION), (0, exports.setDerivation)(derivation)));
        }
    }
    if (udl.dataModelTrainings) {
        for (let dataModelTraining of udl.dataModelTrainings) {
            tags.push(new contract_1.Tag((0, exports.setDuration)(dataModelTraining, udl_1.tagNames.DATA_MODEL_TRAINING), (0, exports.setDataModelTraining)(dataModelTraining)));
        }
    }
    if (udl.expires) {
        tags.push(new contract_1.Tag(udl_1.tagNames.EXPIRY, udl.expires));
    }
    if (udl.currency) {
        tags.push(new contract_1.Tag(udl_1.tagNames.CURRENCY, udl.currency));
    }
    if (udl.paymentMode) {
        tags.push(new contract_1.Tag(udl_1.tagNames.PAYMENT_MODE, udl.paymentMode));
    }
    if (udl.paymentAddress) {
        tags.push(new contract_1.Tag(udl_1.tagNames.PAYMENT_ADDRESS, udl.paymentAddress));
    }
    if (udl.unknownUsageRights && udl.unknownUsageRights === "Excluded") {
        tags.push(new contract_1.Tag(udl_1.tagNames.UNKNOWN_USAGE_RIGHTS, "Excluded"));
    }
    return tags;
};
exports.udlToTags = udlToTags;
const setDuration = (udlField, tagName) => {
    if (udlField.duration) {
        return udlField.duration.type + "-" + udlField.duration.value + "-Years-" + tagName;
    }
    else {
        return tagName;
    }
};
exports.setDuration = setDuration;
const setLicenseFee = (licenseFee) => {
    return licenseFee.type + "-" + licenseFee.value;
};
exports.setLicenseFee = setLicenseFee;
const setDataModelTraining = (dataModelTraining) => {
    let derivationValue = dataModelTraining.type;
    if (dataModelTraining.type === "Allowed-With-Fee") {
        if (!dataModelTraining.fee) {
            throw new bad_request_1.BadRequest("Incorrect UDL format: Derivation With Fee must specify fee.");
        }
        const fee = dataModelTraining.fee.type + "-" + dataModelTraining.fee.value;
        derivationValue = dataModelTraining.type + "-" + fee;
    }
    return derivationValue;
};
exports.setDataModelTraining = setDataModelTraining;
const setDerivation = (derivation) => {
    let derivationValue = derivation.type;
    if (derivation.type === "Allowed-With-RevenueShare") {
        if (!derivation.value) {
            throw new bad_request_1.BadRequest("Incorrect UDL format: Derivation With Revenue Share must specify % value.");
        }
        derivationValue = derivationValue + "-" + derivation.value + "%";
    }
    if (derivation.type === "Allowed-With-Fee") {
        if (!derivation.fee) {
            throw new bad_request_1.BadRequest("Incorrect UDL format: Derivation With Fee must specify fee.");
        }
        const fee = derivation.fee.type + "-" + derivation.fee.value;
        derivationValue = derivation.type + "-" + fee;
    }
    return derivationValue;
};
exports.setDerivation = setDerivation;
